import PropTypes from 'prop-types'
import React from 'react'
import PageHeader from 'components/util/PageHeader'
import { FormattedMessage } from 'react-intl'
import styles from './_routeSearchTitle.css'
import Button from 'components/util/Button'

export default function RouteSearchTitle ({ site }) {
  let title = <FormattedMessage id='routesearch.title.fit' defaultMessage='Search for fitness training routes' />

  if (site === 'run') {
    title = <FormattedMessage id='routesearch.title.run' defaultMessage='Search for running routes' />
  } else if (site === 'ride') {
    title = <FormattedMessage id='routesearch.title.walk' defaultMessage='Search for bike path & bicycling routes' />
  } else if (site === 'walk') {
    title = <FormattedMessage id='routesearch.title.ride' defaultMessage='Search for walking routes' />
  } else if (site === 'hike') {
    title = <FormattedMessage id='routesearch.title.hike' defaultMessage='Search for hiking trails and routes' />
  }

  return (
    <PageHeader>
      <div className={styles.routeSearchTitle}>
        <h1>{title}</h1>
        <a className={styles.createRouteLink} href='/routes/create'>
          <Button
            el='button'
            type='secondary'
            size='medium'>
            <FormattedMessage id='routesearch.title' defaultMessage='Create a route' />
          </Button>
        </a>
      </div>
    </PageHeader>
  )
}

RouteSearchTitle.propTypes = {
  site: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/routes/search/RouteSearchTitle.jsx